// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--2LzUo","heading":"styles-module--heading--1Jg13","categories":"styles-module--categories--2G87J","isVisible":"styles-module--isVisible--JVaV5"};